module.exports = "/lucky-balls/img/bonus_yellow/check_infoBar/check_012.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/bonus_yellow/check_infoBar/check_012.png
// module id = 957
// module chunks = 0